import { application } from "./application"

import RepertoireItemsController from "./repertoire_items_controller"
application.register("repertoire-items", RepertoireItemsController)

import HelloController from "./hello_controller"
import ToastController from "./toast_controller"
import CalendarController from "./calendar_controller"
import RichtextController from "./richtext_controller"
import FlatpickrController from "./flatpickr_controller"

application.register("hello", HelloController)
application.register("toast", ToastController)
application.register("calendar", CalendarController)
application.register("richtext", RichtextController)
application.register("flatpickr", FlatpickrController)
